import React, {useState} from 'react';
import panneauxSolaire from "../../images/panneauxSolaire.jpg";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Card, CardActions, CardContent} from "@mui/material";
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import Button from "@mui/material/Button";
import EngineeringIcon from '@mui/icons-material/Engineering';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import Grid2 from "@mui/material/Unstable_Grid2";
import panneauSolaireSchema from "../../images/panneauxSolaireSchema.jpg";
import panneauxPhotoSchema from "../../images/panneauxPhotoSchema2.jpg";
import installationPanneau from "../../images/installationPanneau.jpg";
import ContactUs from "../ContactUs";
import Partenaires from "../Partenaires";
import AnimatedBackgroundBox from "../AnimationBackgroundBox";

const EnergieRen = () => {
        const [formData, setFormData] = useState({
            name: '',
            email: '',
            compagny: '',
            phoneNumber:'',
            message: '',
        });

        // Permet de mettre a jour les data saisies par l'user
        const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value,
            });
        };
    return (
        <React.Fragment>
            <AnimatedBackgroundBox backgroundImage={panneauxSolaire} position={'center'} size={'200%'}>
                <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ebefef', fontFamily: 'unset',
                    textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.5),   
                            0px 0px 16px rgba(0, 0, 0, 0.5),  
                            0px 0px 24px rgba(0, 0, 0, 0.5)   
                        `,
                    fontSize: {
                        xs: '2.5rem', // Taille plus petite sur les téléphones
                        sm: '2.5rem', // Taille moyenne sur les tablettes
                        md: '5rem', // Taille normale sur les grands écrans
                    },
                }}>
                    Panneaux Solaires
                </Typography>
                {/*            <Typography variant="body2" sx={{ color: 'text.secondary' }}>*/}
                {/*                Optez pour une énergie propre et durable.*/}
                {/*                Nous installons des panneaux solaires et autres solutions renouvelables*/}
                {/*                pour réduire votre empreinte carbone.*/}
                {/*            </Typography>*/}
        </AnimatedBackgroundBox>

            <Box sx={{ padding: { xs: '20px', md: '70px 0' }, backgroundColor: '#f0f4fa' }}>
                <Box sx={{ maxWidth: 'lg', margin: 'auto', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                    {/* Contenu principal avec centrage horizontal */}
                    <Grid2 container spacing={7} justifyContent="center" alignItems="stretch"> {/* 'stretch' pour égaliser la hauteur des colonnes */}
                        <Grid2 xs={12} md={12}>
                            <Typography variant="h3" textAlign="center" sx={{ fontSize: { xs: '2rem' }, fontFamily: 'unset' }}>
                                Quelle est la différence entre un panneau solaire et un panneau photovoltaïque ?
                            </Typography>
                        </Grid2>
                        <Grid2 container spacing={4} justifyContent="center" alignItems="stretch"> {/* 'stretch' pour égaliser la hauteur des colonnes */}
                            {/* Première colonne */}
                            <Grid2 xs={12} md={6}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between', // Utiliser 'space-between' pour répartir l'espace
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        height: '100%' // Prendre toute la hauteur disponible
                                    }}
                                >
                                    <Typography variant="h4" sx={{ paddingBottom: "10px", color: '#3f72b5', fontWeight: 'bold', fontFamily: 'unset' }}>
                                        Panneau solaire
                                    </Typography>
                                    <Box sx={{ marginTop: '20px', flexGrow: 1 }}> {/* FlexGrow pour occuper l'espace restant */}
                                        <img src={panneauSolaireSchema} alt="Panneau solaire" style={{ maxWidth: '80%', height: 'auto', borderRadius: '10px' }} />
                                    </Box>
                                    <Typography sx={{ marginTop: '15px', fontFamily: 'unset' }}>
                                        Ce type de panneau capte l'énergie du soleil pour la convertir en chaleur, utilisée principalement pour chauffer l'eau sanitaire ou alimenter un système de chauffage.
                                    </Typography>
                                </Box>
                            </Grid2>

                            {/* Deuxième colonne */}
                            <Grid2 xs={12} md={6}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between', // Utiliser 'space-between' pour répartir l'espace
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        height: '100%' // Prendre toute la hauteur disponible
                                    }}
                                >
                                    <Typography variant="h4" sx={{ paddingBottom: "10px", color: '#3f72b5', fontWeight: 'bold', fontFamily: 'unset' }}>
                                        Panneau photovoltaïque
                                    </Typography>
                                    <Box sx={{ marginTop: '20px', flexGrow: 1 }}> {/* FlexGrow pour occuper l'espace restant */}
                                        <img src={panneauxPhotoSchema} alt="Panneau photovoltaïque" style={{ maxWidth: '80%', height: 'auto', borderRadius: '10px' }} />
                                    </Box>
                                    <Typography sx={{ marginTop: '15px', fontFamily: 'unset' }}>
                                        Ce type de panneau capte l'énergie solaire et la transforme directement en électricité grâce à des cellules photovoltaïques. Elle peut ensuite être utilisée pour alimenter des appareils électriques ou être réinjectée dans le réseau.
                                    </Typography>
                                </Box>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>



            <Box sx={{
                padding: { xs: '20px ', md: '70px 0' },
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${installationPanneau})`,
                position: 'relative',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}>
                <Box sx={{ maxWidth: 'lg', margin: 'auto', display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}> {/* Centrage horizontal du conteneur */}
                    <Grid2 container spacing={4} justifyContent="center"> {/* Centrage des cartes */}
                        {/** Tableau de données pour les cartes */}
                        {[
                            {
                                icon: <SolarPowerIcon sx={{ fontSize: 75, color: '#f6d70d' }} />,
                                title: "INSTALLATIONS DE PANNEAUX SOLAIRES",
                                description: "Passez à l’énergie solaire avec notre service d’installation de panneaux solaires adaptés à vos besoins énergétiques. Optimisez votre consommation tout en réduisant votre facture.",
                                button: null,
                            },
                            {
                                icon: <EngineeringIcon sx={{ fontSize: 75, color: '#83898c' }} />,
                                title: "MAINTENANCE ET ENTRETIEN DES PANNEAUX SOLAIRES",
                                description: "Gardez vos panneaux solaires en parfait état avec nos services de maintenance et d’entretien réguliers, pour une performance optimale toute l’année.",
                                button: null,
                            },
                            {
                                icon: <AutorenewIcon sx={{ fontSize: 75, color: '#32b828' }} />,
                                title: "AUTOCONSOMMATION SOLAIRE",
                                description: "Profitez pleinement de l’énergie produite par vos panneaux solaires et devenez autonome en électricité grâce à nos solutions d’autoconsommation.",
                                button: null,
                            },
                            {
                                icon: <EuroSymbolIcon sx={{ fontSize: 75, color: '#05acf3' }} />,
                                title: "SUBVENTIONS & AIDES",
                                description: "Profitez des subventions et aides disponibles pour financer l’installation de vos panneaux solaires et passer à l’énergie renouvelable.",
                                button: (
                                    <Button
                                        href={"https://www.economie.gouv.fr/particuliers/aides-installation-photovoltaiques"}
                                        size="small"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        En savoir plus
                                    </Button>
                                ),
                            },
                        ].map((card, index) => (
                            <Grid2 xs={12} sm={6} md={6} key={index}>
                                <Card
                                    sx={{
                                        minWidth: 300,
                                        minHeight: 300,
                                        maxHeight: 350,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 8,
                                        boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.2)' // Ombre plus accentuée
                                        //boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '

                                    }}
                                >
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                                            {card.icon}
                                        </Box>
                                        <Typography variant='h5' sx={{ textAlign: 'center', mb: 1.5, fontFamily: 'unset' }}>
                                            {card.title}
                                        </Typography>
                                        <Typography variant="body1" sx={{ textAlign: 'center', fontFamily: 'unset' }}>
                                            {card.description}
                                        </Typography>
                                    </CardContent>
                                    {card.button && (
                                        <CardActions>
                                            {card.button}
                                        </CardActions>
                                    )}
                                </Card>
                            </Grid2>
                        ))}
                    </Grid2>
                </Box>
            </Box>

            <Box>
                <Partenaires></Partenaires>
            </Box>
            <Box>
              <ContactUs></ContactUs>
            </Box>
        </React.Fragment>
    );
};
export default EnergieRen;